export default __webpack_public_path__ + "static/media/ter.ff07522b.jpg";